import { createSelector } from "reselect";

const authSelector = state => state.auth;

export const isLoadingSelector = createSelector(authSelector, state => state.isLoading);
export const isErrorSelector = createSelector(authSelector, state => state.isError);
export const authFormSelector = createSelector(authSelector, state => state.authForm);
